import { Popconfirm, TimePicker } from "antd";
import React, { useEffect, useState } from 'react';
import { callNotify } from "../../../../../../..";
import Icon, { ICON_NAME } from "../../../../../../../components/Icon";
import { datetime } from "../../../../../../../util/library/datetime";
import { propContainer, propsConfirm } from "../../../../../../../util/varibles/constants";
import stylesContainer from "../../style.module.scss";
import styles from "./style.module.scss";

interface IProps {
    value: any
    isDisable: boolean

    onChange(value: any): void

    onDelete(): void
}

const Time: React.FC<IProps> = (props) => {
    const [focus, setFocus] = useState(false);
    const [arrivalTime, setArrivalTime]: any | null = useState(undefined);
    const [isDelete, setIsDelete] = useState(false);

    const { value, isDisable } = props;

    useEffect(() => {
        if (value !== null && value !== undefined) {
            const hour = Math.floor(value / 60);
            const minute = Math.floor(value - (hour * 60));
            setArrivalTime(datetime().set({ hour, minute }).value)
        } else {
            setArrivalTime(undefined)
        }
    }, [value]);

    const handleFocus = () => {
        setFocus(true);
    }

    const handleChange = (value: any) => {
        if (value == null) {
            callNotify?.error({ title: 'Error', description: 'Time is required' })
            return;
        }

        const time = datetime(value);
        const hour = time.hour;
        const minus = time.minute;
        props.onChange((hour * 60) + minus)
        setFocus(false);
    }

    const handleDelete = () => {
        props.onDelete();
        setIsDelete(false);
    }

    if (isDisable)
        return null;

    return <div className={styles.wrapper}>
        {(arrivalTime || focus)
            ? <TimePicker
                {...propContainer}
                showNow={false}
                value={arrivalTime}
                open={focus}
                variant={"borderless"}
                className={stylesContainer.picker}
                classNames={{
                    popup: { root: stylesContainer['popup-picker'] }
                }}
                minuteStep={5}
                format={'HH:mm'}
                placeholder={''}
                onChange={handleChange}
                onOpenChange={setFocus}
            />
            : <div className='bt-ghost' data-icon={true} onClick={handleFocus}>
                <Icon icon={ICON_NAME.EDIT} size='large' />
            </div>}
        {arrivalTime && <Popconfirm
            {...propsConfirm}
            title="Are you sure to delete this setting?"
            open={isDelete}
            onConfirm={handleDelete}
            onCancel={() => setIsDelete(false)}
        >
            <div className='bt-ghost' data-icon={true} data-danger='true' data-show={isDelete}
                onClick={() => setIsDelete(true)}>
                <Icon icon={ICON_NAME.DELETE} size='large' />
            </div>
        </Popconfirm>}
    </div>;
};


export default Time;
